import { render, staticRenderFns } from "./ShareProjectModal.vue?vue&type=template&id=1915310a&scoped=true&"
import script from "./ShareProjectModal.vue?vue&type=script&lang=js&"
export * from "./ShareProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareProjectModal.vue?vue&type=style&index=0&id=1915310a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1915310a",
  null
  
)

export default component.exports